import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BancoIntegracion } from '../../../../core/models';
import { UiButtonComponent } from '../../../../shared/ui-button/ui-button';

@Component({
  selector: 'app-bank-integrations-panel',
  standalone: true,
  imports: [UiButtonComponent],
  templateUrl: './bank-integrations-panel.html',
  styleUrl: './bank-integrations-panel.css',
})
export class BankIntegrationsPanelComponent {
  @Input() bankName = '';
  @Input() integrations: BancoIntegracion[] = [];
  @Input() testingId: string | null = null;

  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<BancoIntegracion>();
  @Output() test = new EventEmitter<BancoIntegracion>();
  @Output() toggle = new EventEmitter<BancoIntegracion>();
}
